import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import TokenService from '@/common/token.service';

export default new Vuex.Store({
  state: {
    isAuthPage: false,
    isLogin: false,
    token: '',
    accountName: ''
  },
  mutations: {
    ['setAuth'](state, flag) {
      state.isAuthPage = flag;
    },
    ['clearLogin'](state) {
      state.isLogin = false;
      state.token = '';
      state.accountName = '';
      TokenService.destroyToken();
    },
    ['login'](state, payload) {
      state.isLogin = true;
      state.token = payload.token;
      state.accountName = payload.accountName;
      TokenService.saveToken(payload.token);
    },
    ['checkLogin'](state) {
      if (TokenService.getToken()) {
        state.isLogin = true;
        state.token = TokenService.getToken();
        return true;
      } else {
        state.isLogin = false;
        state.token = '';
        return false;
      }
    }
  },
  actions: {},
  getters: {
    isLogin: state => state.isLogin,
    isAuth: state => state.isAuthPage,
    token: state => state.token,
    accountName: state => state.accountName
  }
});
